import { registerComponent } from './components-front'

registerComponent('image-to-svg', function() {
    [...document.querySelectorAll('img')].filter(img => {
        return img.classList.contains('svg-replace');
    }).forEach(img => {
        const id = img.getAttribute('id')
        const src = img.getAttribute('src');
        const classList = [...img.classList];
        const style = img.getAttribute('style')

        fetch(src)
            .then(response => {
                if (!response.ok) throw new Error(`SVG request failed: ${response.status} ${src}`);
                return response.text();
            })
            .then(data => {
                const svg = createElement(data);
                scopeIds(svg);
                svg.classList.add(...classList);
                svg.id = id || '';
                if (svg.hasAttribute('style')) {
                    svg.setAttribute('style', svg.getAttribute('style') + ';' + style)
                } else {
                    svg.setAttribute('style', style)
                }
                img.parentNode.insertBefore(svg, img);
                img.parentNode.removeChild(img);
            })
            .catch(err => console.error(err));
    })
});

let inlinedCount = 0;

// Exported SVGs reuse ids like "clip-path", and once several are inlined every url(#clip-path) resolves to the first one on the page
function scopeIds(svg) {
    const suffix = `-svg${++inlinedCount}`;
    const ids = new Map();
    svg.querySelectorAll('[id]').forEach(el => {
        ids.set(el.id, el.id + suffix);
        el.id += suffix;
    });
    if (!ids.size) return;

    svg.querySelectorAll('*').forEach(el => {
        [...el.attributes].forEach(attr => {
            let value = attr.value.replace(/url\((['"]?)#([^'")]+)\1\)/g, (match, quote, id) => {
                return ids.has(id) ? `url(${quote}#${ids.get(id)}${quote})` : match;
            });
            if ((attr.name === 'href' || attr.name === 'xlink:href') && ids.has(value.slice(1))) {
                value = '#' + ids.get(value.slice(1));
            }
            if (value !== attr.value) attr.value = value;
        });
    });
}

function createElement(html) {
    const frag = document.createDocumentFragment();

    const elem = document.createElement('div');
    elem.innerHTML = html;

    while (elem.childNodes[0]) {
        frag.appendChild(elem.childNodes[0]);
    }
    return frag.childNodes[0];
}
